// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gdpr-modal-container .modal {
  display: block !important;
}

.modal-dialog-gdpr {
  overflow-y: visible !important;
  overflow-y: initial !important;
  max-width: 1120px !important;
}

.modal-body-gdpr {
  height: 500px;
  overflow-y: auto;
  border: 1px solid #e50000 !important;
  margin-left: 20px;
  margin-right: 20px;
  padding: 5px;
}
.modal-title-gdpr {
  color:#0a0a0A !important;
  font-size: 0.9rem !important;
  font-weight: bolder !important;
  padding-right: 25px !important;
}

.gdpr-modal-container b,
.gdpr-modal-container strong {
  font-weight: bold !important;
}

.gdpr-disableAutoSuggest {
  background-color: hsl(0, 0%, 95%)!important;
  border-color: hsl(0, 0%, 90%)!important;
  color: hsl(0, 0%, 60%)!important;
  align-self: right;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  margin: 4px 2px;
  cursor: pointer;
  border-radius: 1.25rem;
  height: 2.2rem;
  padding: 0rem 50px;
}

.modal-dialog-gdpr .modal-content{
  border-radius: 24px !important ;
}

.gdpr-modal-container img {
  vertical-align: middle !important;
  border-style: none;
  padding-right: 70px;
}

.gdpr-modal-container .stylePadding{
padding-right:5px;
}

.modal-header-gdpr .close {
  color: #e50000 !important;
}

.gdpr-modal-container {
  font-family: Arial, Helvetica, sans-serif;
}


.gdpr-modal-container .modal-body-gdpr table tbody tr {
border: none !important;
}


.gdpr-modal-container .disabled, :disabled {
  pointer-events: none !important;
  color: grey ;
}
`, "",{"version":3,"sources":["webpack://./src/components/gdpr/index.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAA9B,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,oCAAoC;EACpC,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,wBAAwB;EACxB,4BAA4B;EAC5B,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;EACE,2CAA2C;EAC3C,uCAAuC;EACvC,gCAAgC;EAChC,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;EACrB,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;AACA,iBAAiB;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;AAC3C;;;AAGA;AACA,uBAAuB;AACvB;;;AAGA;EACE,+BAA+B;EAC/B,YAAY;AACd","sourcesContent":[".gdpr-modal-container .modal {\n  display: block !important;\n}\n\n.modal-dialog-gdpr {\n  overflow-y: initial !important;\n  max-width: 1120px !important;\n}\n\n.modal-body-gdpr {\n  height: 500px;\n  overflow-y: auto;\n  border: 1px solid #e50000 !important;\n  margin-left: 20px;\n  margin-right: 20px;\n  padding: 5px;\n}\n.modal-title-gdpr {\n  color:#0a0a0A !important;\n  font-size: 0.9rem !important;\n  font-weight: bolder !important;\n  padding-right: 25px !important;\n}\n\n.gdpr-modal-container b,\n.gdpr-modal-container strong {\n  font-weight: bold !important;\n}\n\n.gdpr-disableAutoSuggest {\n  background-color: hsl(0, 0%, 95%)!important;\n  border-color: hsl(0, 0%, 90%)!important;\n  color: hsl(0, 0%, 60%)!important;\n  align-self: right;\n  text-align: center;\n  text-decoration: none;\n  display: inline-block;\n  margin: 4px 2px;\n  cursor: pointer;\n  border-radius: 1.25rem;\n  height: 2.2rem;\n  padding: 0rem 50px;\n}\n\n.modal-dialog-gdpr .modal-content{\n  border-radius: 24px !important ;\n}\n\n.gdpr-modal-container img {\n  vertical-align: middle !important;\n  border-style: none;\n  padding-right: 70px;\n}\n\n.gdpr-modal-container .stylePadding{\npadding-right:5px;\n}\n\n.modal-header-gdpr .close {\n  color: #e50000 !important;\n}\n\n.gdpr-modal-container {\n  font-family: Arial, Helvetica, sans-serif;\n}\n\n\n.gdpr-modal-container .modal-body-gdpr table tbody tr {\nborder: none !important;\n}\n\n\n.gdpr-modal-container .disabled, :disabled {\n  pointer-events: none !important;\n  color: grey ;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
